export default {
    tabbar: {
        home: 'Casa',
        trading: 'Commercio',
        invest: 'Investire',
        share: 'Condividere',
        mine: 'Mio'
    },
    common: {
        deposit: 'Depositare',
        withdrawal: 'Ritiro',
        share: 'Condividere',
        team: 'Squadra',
        task: 'Compito',
        addr: 'Indirizzo',
        logout: 'Disconnettersi',
        wallet: 'Portafoglio',
        account: 'Account',
        promotion: 'Promozione',
        details: 'Dettagli',
        dailyRevenue: 'entrate giornaliere',
        dailyRevenueList: 'Elenco delle entrate giornaliere',
        aboutUs: 'Chi siamo',
        globalPartners: 'Partner globali',
        totalBalance: 'Saldo totale',
        profitList: 'Elenco dei profitti finanziari',
        notification: 'Notifica',
        previous: 'Precedente',
        close: 'Vicina',
        next: 'Prossima',
        investWallet: 'Portafoglio per investimenti',
        financialWallet: 'Portafoglio finanziario',
        recharge: 'Ricaricare',
        copySucceeded: 'copia riuscita',
        copyFailed: 'copia non riuscita',
        promotionWallet: 'Portafoglio promozionale',
        registerRewardWallet: 'Registra il portafoglio premi',
        toAddress: 'Indirizzo del portafoglio TRON (inizia con T) per la raccolta',
        verifyYourPassword: 'Verifica la tua password di sicurezza',
        serviceFee: 'Gas fees',
        confirm: 'Confermare',
        submitted: 'presentato',
        date: 'Data',
        amount: 'Quantità',
        accountAvailableBalance: 'Saldo disponibile del conto',
        securityPassword: 'Password di sicurezza',
        withdrawalPrincipal: 'Ritiro del capitale',
        withdrawalProfit: 'Ritiro degli utili',
        profitRate: 'Tasso d\'interesse',
        notificationAndFAQ: 'FAQ e avvisi',
        FAQ: 'FAQ',
        FAQs: [
            {
                id: 'q1',
                title: 'Q:Caratteristiche/introduzione del progetto',
                content: `R:
1. Essendo il primo e comprovato codice di investimento certificato del settore, la nostra soluzione mira a dimostrare che i contratti intelligenti sono il futuro degli investimenti. La sua longevità e stabilità finiranno per sconvolgere il settore delle criptovalute e il modo in cui le persone pensano agli investimenti e al trading. L’industria dei token convenzionali deve affrontare molte sfide, tra cui truffe sui token, ostacoli, volatilità del mercato, sviluppatori disonesti che rubano i fondi degli utenti e mancanza di liquidità.

2. Il codice di affidabilità di cui disponiamo si basa sulla struttura della soluzione e la nostra soluzione non sarà influenzata in alcun modo da queste e molte altre sfide che si presentano nel settore delle criptovalute. La nostra piattaforma non richiede liquidità di mercato. Pertanto, il tuo investimento e il tuo reddito atteso sono sicuri perché non dipendiamo dai cambiamenti del settore. Invece, abbiamo creato una soluzione basata sull'attrattiva di nuovi utenti ma basata su contratti intelligenti! Il nostro codice e la nostra struttura sono sicuri, con longevità e trasparenza garantite. Pertanto, disponiamo di un programma di riferimento molto attraente e solido con statistiche dettagliate e trasparenti per ciascun promotore/utente. I guadagni dell'originatore, così come quelli di altri utenti, vengono immediatamente aggiunti al profilo e, a differenza di altre soluzioni di investimento DeFi, le persone possono prelevare istantaneamente i fondi in qualsiasi momento.`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q2',
                title: 'Q:Qual è il nostro vantaggio?',
                content: `R:I nostri sistemi sono controllati dal team di sicurezza Haze e dispongono di revisori Smart Contract indipendenti
1. Sicuro e affidabile: non è necessario trasferire valuta, USDT viene depositato nel tuo portafoglio con rischio zero
2. Stabilità professionale: squadra di professionisti, funzionamento stabile durante tutto l'anno
3. Soglia di ingresso bassa: condividi il reddito minerario del nodo
4.USD ETHW AI Strategy-C Mining Pool: nessuna necessità di trasferire valuta, reddito stabile
5. Ci impegniamo a costruire la più grande piattaforma DeFi integrata al mondo DEX, IMO e DAO`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q3',
                title: 'Q:Come posso essere coinvolto?',
                content: `R:
1. Il portafoglio è sulla catena e la stazione del portafoglio è dotata di un browser Dapp.
2. Collega TRC20 a USDT e depositalo nel tuo portafoglio
3. Inserisci Gongwang tramite il browser del portafoglio
4. Il tuo portafoglio deve avere più di 30 trx come commissioni minerarie per partecipare a questo progetto
`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q4',
                title: 'Q:Quanto tempo ci vuole per partecipare al mining?',
                content: `R:Non è possibile calcolare il tempo. Normalmente può essere completato entro 4 ore. Se si riscontrano altri motivi incerti, il tempo può essere prolungato.`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q5',
                title: 'Q:Perché dobbiamo pagare le tasse minerarie per incassare i profitti?',
                content: `R:Perché in questo processo di partecipazione al mining, i clienti vengono contati solo per nome e le commissioni minerarie generate sono state pagate dai minatori. Il reddito generato è effettivamente nel pool del contratto e solo pagando le commissioni minerarie puoi scambiarlo con reddito.`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q6',
                title: 'Q:Come ritirare i profitti?',
                content: `R:Dopo aver ottenuto USDT, devi avere una piccola quantità di TRX nel tuo portafoglio per le commissioni di transazione. Devi pagare solo una volta e lo scambio USDT sarà completato entro un giorno lavorativo legale. Quando avvii un prelievo, il prelievo USDT verrà automaticamente inviato all'indirizzo del portafoglio del nodo a cui ti sei iscritto. Altri indirizzi non sono supportati.`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q7',
                title: 'Q:Cos\'è l\'estrazione di liquidità Defi?',
                content: `R:L’estrazione di liquidità è un tipo di finanza decentralizzata DeFi. Non ha bisogno di acquistare schede grafiche, di fornire potenza di calcolo o di pagare costose bollette elettriche, ma guadagna fornendo fondi e liquidità. Soprattutto di recente, i prezzi delle valute hanno oscillato notevolmente. Per alcuni detentori di monete impegnati, l'estrazione di liquidità è un modo per guadagnare reddito e accumulare più criptovaluta senza la necessità di transazioni.`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q8',
                title: 'Q:Come funziona?',
                content: `R:La nostra soluzione è un accordo di transazione computerizzato che applica automaticamente i termini di un contratto tra due parti. Similmente ai contratti universali, entrambi gli utenti della nostra piattaforma devono definire le regole e i termini di partecipazione durante il trading. Una volta raggiunto un accordo e avviato un contratto intelligente, funziona come previsto, con zero possibilità di modifica delle condizioni predeterminate. Quando un utente avvia un’attività nel mining pool di un nodo blockchain, deve esserci un saldo disponibile sul contratto. Il resto degli utenti lascia che il contratto venga eseguito, senza dover più aspettare lunghe ore per verificare quando vendere o acquistare. Pertanto, secondo i termini del contratto, è garantito che il valore del tuo investimento non diminuirà mai; al contrario, porta il 100% di profitto ai nostri utenti.`,
                updatedAt: '2019-07-23 12:00:00'
            }
        ],
        minWithdrawalError: 'L\'importo del prelievo deve essere superiore alla tariffa del gas consumato',
        supportTips: 'Gentile utente: abbiamo creato per te un esclusivo servizio di assistente del pool minerario. Puoi scriverci per consulenze, reclami, suggerimenti, ecc. E ti risponderemo e gestiremo il problema entro 24 ore!',
        tips: 'Punte',
        Withdrawals_prohibited: 'Le condizioni di prelievo non sono attualmente soddisfatte, completa prima l\'attività.'
    },
    homePage: {
        theCommonProblem: 'Il problema comune',
        latestAnnouncement: 'Ultimo annuncio',
        block5title: 'Iscriviti per diventare milionario TRON',
        block5desc: 'Utilizza il cloud mining e la tecnologia Defi per garantire che tutti gli utenti ottengano il massimo delle entrate USDT.',
        block6title: 'Visualizzazione dei dati della piattaforma',
        accumulatedProfit: 'Profitto accumulato',
        membership: 'Appartenenza',
        block7title: 'Siamo al nostro meglio',
        block7desc: 'hako è una società registrata a Singapore, numero di licenza: PS20200556. Siamo l\'unico sito Web di investimento in contratti intelligenti controllato e verificato nello spazio delle criptovalute che opera sulla rete TRON Smart Chain (TRON). hako cloud mining offre una pipeline di mining potenzialmente conveniente per Bitcoin USDT e altre criptovalute. Allo stesso tempo, sia il trading quantitativo che la tecnologia DeFi ti permetteranno di partecipare facilmente alle transazioni blockchain con una piccola quantità di capitale e ottenere un reddito stabile come un’assicurazione.',
        tzl: 'investito',
        zl: 'guadagnata'
    },
    investPage: {
        productList: 'Elenco prodotti',
        investedList: 'Elenco investito',
        dailyRate: 'Tariffa giornaliera',
        cycle: 'ciclo',
        day: 'Giorno',
        productDetails: 'Dettagli del prodotto'
    },
    tradingPage: {
        miningWorking: 'Il Cloud Mining funziona',
        tradingProfit: 'Profitto commerciale',
        settlementRule: 'Liquidazione 24 ore su 24',
        viewAll: 'Mostra tutto',
        quantifyingTransactionRevenue: 'Reddito da negoziazione qualitativo',
        receive: 'Ricevere',
        received: 'Ricevuto',
        rule: 'Regole minerarie',
        rules: 'Se vuoi che "Cloud Mining" inizi a funzionare e guadagni un reddito giornaliero, attivalo nel "Portafoglio finanziario". Quando il saldo USDT nel tuo portafoglio soddisfa determinate condizioni, riceverai un reddito giornaliero e il reddito generato verrà trattenuto per 30 giorni. Fare clic per richiederlo in tempo. Calcola la percentuale delle tue entrate giornaliere in base alla tabella seguente:',
        profit: 'Profitto',
        miningNotWorking: 'Il cloud mining non funziona, attivalo',
        balance: 'bilancia'
    },
    sharePage: {
        text1: 'Invita i tuoi contatti',
        text2: 'o amici e guadagna premi',
        text3: 'Segnala e guadagna premi',
        text4: 'Condividi il tuo link di riferimento e inizia a guadagnare',
        copyLink: 'Copia link'
    },
    minePage: {
        trxDepositInvestment: 'Investimento in depositi USDT',
        trxDepositFinancial: 'USDT Deposito finanziario',
        tips: 'Ricarica un numero qualsiasi di USDT per attivare il conto e aprire la funzione di prelievo.',
        appServices: 'Servizi dell\'app'
    },
    depositPage: {
        text1: 'L\'investimento è diviso in due modalità',
        text2: '1: Ricarica nel portafoglio di investimento, puoi ricevere reddito in base a cicli diversi, restituire il capitale e il reddito alla scadenza',
        text3: '2:Attiva la funzione "cloud mining" nel tuo portafoglio finanziario e ricevi entrate secondo il fuso orario di Singapore (dopo le 12) ogni giorno',
        text4: 'Nota:',
        text5: 'Prima di investire, scegli un conto di investimento o un conto finanziario per investire in base alle tue esigenze di investimento. Assicurati di attendere che il conto venga ricaricato. Questo è un problema molto critico. '
    },
    rechargePage: {
        trxAddress: 'Indirizzo TRC20-USDT',
        copyAddress: 'Copia indirizzo',
        tips1: 'Si prega di non ricaricare altri asset non USDT. Verrà registrato circa 5~10 minuti dopo la ricarica.',
        tips2: `Se non è arrivato da molto tempo, aggiorna questa pagina. Investimento minimo di 5 USDT.`,
        rechargeCompleted: 'Ricarica completata',
        inactivated: 'Inattivata',
        activated: 'Attivato',
        tips3: 'Non è necessario fare clic ripetutamente. Il cloud mining inizia a funzionare circa 5-10 minuti dopo l\'invio della richiesta.',
        tips4: 'Se non è stato attivato per molto tempo, fare nuovamente clic sul pulsante di attivazione.',
        ActivateCloudMining: 'Attiva il cloud mining'
    },
    withdrawalPage: {
        text1: 'Saldo del conto di base (USDT)',
        text2: 'Il ritiro verrà ricevuto entro 24 ore',
        dailyWithdrawalLimit: 'Limite di prelievo giornaliero',
        unlimit: 'illimitata'
    },
    teamPage: {
        intro: 'Gli utenti che inviti direttamente e indirettamente possono guadagnare dividendi per te. Supponiamo di invitare l\'utente A, le entrate finanziarie ottenute dall\'utente A verranno inviate al tuo portafoglio come ricompensa percentuale. Se l\'utente A invita l\'utente B e B a sua volta invita C, puoi ottenere una ricompensa percentuale del reddito dell\'utente A ({lev2rate}%), B ({lev3rate}%), C ({lev4rate}%)!',
        level: 'Livello',
        lev2: 'lv.2',
        lev3: 'lv.3',
        lev4: 'lv.4',
        quantity: 'Quantità',
        rewards: 'Premi'
    },
    productDetailsPage: {
        startingAmount: 'Importo iniziale',
        maxInvestmentAmount: 'Importo massimo dell\'investimento',
        dailyInterestRate: 'Tasso di interesse giornaliero',
        investableQuantity: 'Quantità investibile',
        investmentAmount: 'Importo dell\'investimento',
        participateInInvestment: 'Partecipare agli investimenti'
    },
    investedListPage: {
        investmentTime: 'Tempo di investimento',
        settlementTime: 'Tempo di liquidazione',
        settlementAmount: 'Importo di liquidazione'
    },
    loginPage: {
        MobileNumber: 'Mobile number',
        LoginPassword: 'Login password',
        SignIn: 'Sign in',
        SignUp: 'Sign up',
        rememberThePassword: ' remember the password',
        inviteCode: 'Invite code',
        captcha: 'Captcha',
        EncryptedRegistration: 'Encrypted registration',
        desc: 'The password is stored in a decentralized way and cannot be retrieved after it is lost. Please remember your password. ',
        registerSuccess: 'Account created successfully'
    },
    taskPage: {
        desc: 'Ogni importo di ricarica effettivo dei membri subordinati che inviti a registrarsi verrà convertito nel tuo limite di prelievo (conto premio promozionale) in una determinata proporzione',
        rwconvertRate: 'Scala di conversione',
        totalLimit: 'Limite cumulativo',
        availableLimit: 'Credito disponibile',
        contactService: 'Contattare il Servizio Clienti'
    },
    Please_unlock_your_wallet: 'Per favore, sblocca il tuo portafoglio',
    Please_open_the_website_in_the_Dapp_browser: 'Aprire il sito Web nel browser Dapp'
}
